import React from "react";
import SessionsHistoryContainer from "./sessions-history/sessions-history-container";
import AiAssistent from "./ai-assistent";

class AiAssistentController extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            session: props.session,
            deviceType: props.deviceType
        }
    }

    componentDidMount(){
        this.props.setShowLeftMenu(true);
        this.props.setLeftMenuComponent(<SessionsHistoryContainer />, "history", true)
        this.props.loadAiHealth();
        this.props.loadAiModels();
        if(this.props.deviceType === 'mobile'){
            this.props.setShowLeftMenu(false)
        }
        if(this.props.companyId && this.props.accountId){
            this.props.loadAiSessions(this.props.accountId, this.props.companyId, 200);
            //this.props.loadAiStatistic(this.props.startDate, this.props.endDate, this.props.accountId, this.props.companyId);
        }
        else{
            this.props.getMe();
        }
    }

    

    componentDidUpdate(prevProps) {
        const accountJustLoaded = !prevProps.accountId && this.props.accountId
        const companyJustLoaded = !prevProps.companyId && this.props.companyId
        if(prevProps.session?.id && this.props.session?.id && prevProps.session.id !== this.props.session.id){
            this.setState({
                session: this.props.session
            })
        }
        if (accountJustLoaded || companyJustLoaded) {
            if (this.props.companyId && this.props.accountId && !this.props.isLoading) {
                this.props.loadAiSessions(this.props.accountId, this.props.companyId, 200)
                this.props.loadAiStatistic(this.props.startDate, this.props.endDate, this.props.accountId, this.props.companyId);
            }
        }
        if(prevProps.deviceType !== this.props.deviceType){
            if(this.props.deviceType === 'mobile' || this.props.deviceType === 'tablet'){
                this.props.setShowLeftMenu(false)
            }
            else{
                this.props.setShowLeftMenu(true)
            }
        }
    }

    componentWillUnmount(){
        this.props.setRemoveLeftMenuComponent();
        this.props.setShowLeftMenu(false);
    }

    render(){
        return <AiAssistent {...this.props } />
    }
}

export default AiAssistentController;